// extracted by mini-css-extract-plugin
module.exports = {"container":"pagination_container__1OAZ2","pagination":"pagination_pagination__3tXF3","active":"pagination_active__3yRr1"};